/**
 * Horarios por sucursal:
 * - Los Corales (Caraballeda):
 *   lunes a jueves 11:00 am a 11:00 pm;
 *   viernes a domingo 11:00 am a 12:00 de la noche.
 * - Pariata (Maiquetía):
 *   lunes a jueves 4:00 pm a 11:00 pm;
 *   viernes 11:00 am a 12:00 de la noche;
 *   sábado y domingo 4:00 pm a 12:00 de la noche.
 */

const HORA_APERTURA_MANANA = 11;
const HORA_APERTURA_TARDE = 16;
const HORA_CIERRE_23 = 23;
const HORA_CIERRE_MEDIANOCHE = 24;

/** getDay(): 0 = domingo … 5 = viernes … 6 = sábado */
const LUNES = 1;
const JUEVES = 4;
const VIERNES = 5;

const estaEntre = (hora, minuto, h1, m1, h2, m2) => {
  const desde = h1 * 60 + m1;
  const hasta = h2 * 60 + m2;
  const actual = hora * 60 + minuto;
  return actual >= desde && actual <= hasta;
};

const diaDe = (fecha) => fecha.getDay();

const esLunesAJueves = (dia) => dia >= LUNES && dia <= JUEVES;

/** Viernes, sábado y domingo cierran a medianoche; el resto a las 11:00 pm. */
const horaCierreDelDia = (dia) =>
  esLunesAJueves(dia) ? HORA_CIERRE_23 : HORA_CIERRE_MEDIANOCHE;

/**
 * Textos de horario para mostrar en UI (modal cerrado, footer, etc.).
 */
export const HORARIOS_TEXTO = {
  caraballeda: {
    nombre: "Los Corales (Caraballeda)",
    lineas: [
      "Lunes a jueves: 11:00 am a 11:00 pm",
      "Viernes a domingo: 11:00 am a 12:00 de la noche",
    ],
  },
  maiquetia: {
    nombre: "Pariata (Maiquetía)",
    lineas: [
      "Lunes a jueves: 4:00 pm a 11:00 pm",
      "Viernes: 11:00 am a 12:00 de la noche",
      "Sábado y domingo: 4:00 pm a 12:00 de la noche",
    ],
  },
};

/** true si Los Corales / Caraballeda está abierta. */
export const estaAbiertaCaraballeda = (fecha = new Date()) => {
  const hora = fecha.getHours();
  const minuto = fecha.getMinutes();
  return estaEntre(
    hora,
    minuto,
    HORA_APERTURA_MANANA,
    0,
    horaCierreDelDia(diaDe(fecha)),
    0
  );
};

/** true si Pariata / Maiquetía está abierta. */
export const estaAbiertaMaiquetia = (fecha = new Date()) => {
  const hora = fecha.getHours();
  const minuto = fecha.getMinutes();
  const dia = diaDe(fecha);
  const horaApertura = dia === VIERNES ? HORA_APERTURA_MANANA : HORA_APERTURA_TARDE;
  return estaEntre(hora, minuto, horaApertura, 0, horaCierreDelDia(dia), 0);
};

/** true si al menos una sucursal está dentro de su horario. */
export const estaEnHorarioAtencion = (fecha = new Date()) => {
  return estaAbiertaCaraballeda(fecha) || estaAbiertaMaiquetia(fecha);
};

/** true si debe mostrarse el modal de cerrado (ninguna sucursal abierta). */
export const estaCerradoCaraballeda = (fecha = new Date()) => {
  return !estaEnHorarioAtencion(fecha);
};
